/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import {
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
  BUTTON_COLOR,
} from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { URLS } from '../../errorTextsConstants';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      MAX_CARDINALITY_REACHED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Producto ya contratado',
          msg: ['Has alcanzado el máximo posible de este tipo de equipamiento.'],
          buttons: [
            {
              link: URLS.EQUIPMENT,
              label: 'Volver al listado',
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'produco ya contratado - cardinalidad superada',
        },
      },
      UNAVAILABLE_PRODUCT: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'El equipamiento solicitado no es compatible con tus productos contratados',
          buttons: [
            {
              link: URLS.PACK_CONFIG,
              label: 'Ver productos miMovistar',
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'producto incompatible con parque',
        },
      },
      ALREADY_HIRED_EQUIPMENT: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Ya dispones del equipamiento solicitado',
          buttons: [
            {
              link: URLS.EQUIPMENT,
              label: 'Volver al listado',
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'producto ya contratado',
        },
      },
      DECODER_AVAILABLE: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Ya dispones del equipamiento solicitado',
          msg: ['Podemos ofrecerte una versión más avanzada con conexión WiFi y mejor rendimiento.'],
          buttons: [
            {
              link: URLS.WIFI_DECODER_URL,
              label: 'Ver nuevo producto',
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
            {
              link: URLS.EQUIPMENT,
              label: 'Volver al listado',
              color: BUTTON_COLOR.WHITE_BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'producto ya contratado - mejora disponible',
        },
      },
      UNAVAILABLE_OR_ALREADY_HIRED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Tus producto contratados no son compatibles o ya dispones del equipamiento solicitado',
          buttons: [
            {
              link: URLS.EQUIPMENT,
              label: 'Volver al listado',
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'producto incompatible con parque o ya contratado',
        },
      },
      ROUTER_WIFI_6_NEEDED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Tenemos una alternativa mejor para ti',
          msg: ['Para mejorar la cobertura y velocidad en tu domicilio cambia tu router por el Router Smart WiFi 7.','Una vez instalado, si aún necesitas más cobertura, podrás contratar el Amplificador Smart WiFi 6.'],
          buttons: [
            {
              link: URLS.ROUTER_WIFI_7,
              label: 'Ver Router Smart WiFi 7',
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'necesario router wifi6',
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
